<script>
import Sortable from "sortablejs";

export default {
  name: 'newproducts',
  data() {
    return {
      username: localStorage.getItem('name'),
      stock: [],
      // 表格数据
      loading: true,
      tableData: [],
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      choice: [],
      total: 0,
      optionProps: {
        expandTrigger: 'hover',
        title: "name",
        label: "name",
        value: "id",
        children: "children",
        checkStrictly: true
      },
      NewProducts: {
        id: '',
        code: "",
        name: "",
      },
    }
  },
  mounted() {
    this.getStock()
    this.getList()

  },
  methods: {
    getStock() {
      this.$axios.get("/admin/stock/classSortAndClass").then((res) => {
        this.stock = res.data.data
      })
    },
    // 获取数据
    getList() {
      this.loading = true
      this.$axios.get("/admin/newProducts", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    selectProductType(data) {
      const {value, label} = data;
      this.NewProducts.name = value
      this.NewProducts.code = label
    },
    initSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      // const sortable = new Sortable(el, options);
      // 根据具体需求配置options配置项
      const sortable = new Sortable(el, {
        animation: 150,
        ghostClass: 'blue-background-class',
        onEnd: (evt) => { // 监听拖动结束事件
          // 这里就可以写我们需要传给后台的逻辑代码
          // 我们有了 evt.oldIndex 和 evt.newIndex 这两个参数做索引，我们可以根据绑定在表格上面的 data 这个 Array 找到两个相应的记录。就可以针对数据进行操作啦。
          // 下面将拖拽后的顺序进行修改
          const currRow = this.tableData.splice(evt.oldIndex, 1)[0]
          this.tableData.splice(evt.newIndex, 0, currRow)
        }
      })
    },

    close() {
      this.dialogVisible = false
      this.clearForm()
    },
    clearForm() {
      this.NewProducts.code = ""
      this.NewProducts.name = ""
    },
    handleSelectionChange(v) {
      this.choice = v
    },
    batchDelete() {
      let name = ''
      this.choice.forEach(e => {
        name += e.name + '，'
      })
      this.$confirm('此操作将永久删除' + name + '的新品推荐, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.choice.forEach(e => {
          id += e.id + '_'
        })
        id = id.substring(0, id.length - 1)
        this.$axios.delete("/admin/newProducts/batch/" + id).then((res) => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "新品推荐管理",
            "name": this.username,
            "content": "删除了'" + name + "'的新品推荐"
          })
          this.getList()
          this.$message.success("删除成功")
        }).catch((error) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    deleteNewProducts(e) {
      this.$confirm('此操作将永久删除' + e.name + '的新品推荐, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete("/admin/newProducts/" + e.id).then((res) => {
          this.$message.success('删除成功!');
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "新品推荐管理",
            "name": this.username,
            "content": "删除了" + e.name + "的新品推荐"
          })
          this.getList()
        }).catch((r) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    addNewProducts() {
      if (typeof this.NewProducts.id != "string") {
        let id = "";
        this.NewProducts.id.forEach((item) => {
          id += item + '_'
        })
        this.NewProducts.id = id.substring(0, id.length - 1)
      }
      this.$axios.post("/admin/newProducts", this.NewProducts).then((res) => {
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "新品推荐管理",
          "name": this.username,
          "content": "添加" + this.NewProducts.name + "为新品推荐"
        })
        this.getList()
        this.close()
        this.dialogVisible = false
        this.$message.success('添加成功!');
      }).catch((r) => {
        this.$message.error("修改失败")
      })
    }, out() {
      this.$router.push({name: 'login'})
    }
  }
}
</script>
<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新品推荐管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
      <el-button class="topInput" type="primary" @click="dialogVisible = true">添加商品</el-button>
      <el-button class="topInput" type="danger" @click="batchDelete">批量删除</el-button>
      <!--      可拖拽表格调整展示顺序-->
    </el-header>
    <el-main class="el-main">
      <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          current-row-key="id"
          row-key="id"
          max-height="500">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="商品编号" align="center" width="120"></el-table-column>
        <el-table-column prop="name" label="商品名称" align="center" width="300"></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button @click="deleteNewProducts(scope.row)" type="text" size="medium">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="el-footer" id="page">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :pager-count="11"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-footer>

    <el-dialog title="添加商品" :visible.sync="dialogVisible">
      <el-form :model="NewProducts" :inline="true">
        <el-form-item label="商品">
          <el-cascader
              filterable
              v-model="NewProducts.id"
              :options="stock"
              :props=optionProps
              placeholder="请选择" @change="selectProductType"
              clearable></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="addNewProducts()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.el-header {
  margin-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  margin-bottom: 30px;
}

.el-form .el-form-item {
  margin: 10px;
}

.el-main {
  margin-top: 10px;
  margin-left: 25px;
}

.el-footer {
  text-align: center;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/newproductsView.vue